import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-form',
  templateUrl: './turns-form.component.html',
  styleUrls: ['./turns-form.component.scss']
})
export class TurnsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
